import { gatewayInstance } from "../../axiosInstance";

export const searchCharge = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/charges",
      data,
    );
    return response.data !== null ? response.data : [];
  } catch (e) {
    console.error(e);
  }
};

export const getTemplates = async () => {
  try {
    const response = await gatewayInstance.get(
      "/financeservice/invoice-template",
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getTemplateDetails = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/invoice-template-detail/byintid/${id}`,
    );
    console.log("template details", response.data);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const chargeCreation = async (data) => {
  const response = await gatewayInstance.post(
    "/financeservice/job-charge-creation",
    data,
  );
  return response;
};

export const getJobInfo = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/job-charge-creation/jobinfo/${jobId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getChargesByChhId = async (chhId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/job-charge-creation/by-id/${chhId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getSuppNegoDetailsByJobId = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/job-charge-creation/supp-nego-details/${jobId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateCharges = async (data) => {
  const response = await gatewayInstance.put(
    `/financeservice/job-charge-creation`,
    data,
  );
  return response;
};

export const deleteCharges = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `/financeservice/job-charge-creation/delete-charges`,
      data,
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const saveTemplate = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/save-template`,
      data,
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getChargesFromRatemaster = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/rate-master/charges",
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getAllCharges = async () => {
  try {
    const response = await gatewayInstance.get("/financeservice/pattern/all");
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getAllChargesWithDeduction = async () => {
  try {
    const response = await gatewayInstance.get(
      "/financeservice/pattern/all/deduction",
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getExchangeSelectionValues = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/job-charge-creation/exchange-selection",
      data,
    );
    return response?.data?.map((item) => ({
      key: item.excId,
      text: item.info,
      value: JSON.stringify({
        excId: item.excId,
        excRate: item.excRate,
        curCode: item.curCode,
      }),
      disabled: item.recStatus !== 1,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const getChargeTaxCalculation = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `financeservice/job-charge-creation/calculate/tax`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getAllChargesWithItem = async () => {
  try {
    const response = await gatewayInstance.get(
      "/financeservice/pattern/charge/item",
    );
    const charges = response.data;

    const mappedCharges = charges.map((charge) => {
      const hasItems = charge.items && charge.items.length > 0;

      const mappedItems = hasItems
        ? charge.items.map((item) => ({
            key: item.tem_id,
            value: item.tem_id,
            text: item.tem_name,
            rawItem: item, // keep full item in case needed
          }))
        : [];

      return {
        key: charge.chtId,
        value: charge.chtId,
        text: charge.chtCharge,
        rawCharge: charge, // keep full charge in case needed
        items: mappedItems, // dropdown-ready items array (empty if no items)
      };
    });

    console.log("Mapped charges with items: ", mappedCharges);
    return mappedCharges;
  } catch (e) {
    console.error("Error fetching charges with items:", e);
    return [];
  }
};

export const revertApprovedCharges = async (data) => {
  const response = await gatewayInstance.post(
      "/financeservice/charges/revert-approved-status",
      data,
  );

  return response.data;
};
